import PropTypes from "prop-types";
import React from "react";
import { priceType, subscribeLinkType } from "../common/types";
import { SEGMENT_BZA, SEGMENT_CMC } from "./constants";

export function Hero({
	title,
	subtitle,
	segment,
	features,
	price,
	subscribeLinkUrl,
}) {
	const featuresList = features && (
		<ul className="ticks ticks--small">
			{features.map((feature, index) => (
				<li key={index}>{feature}</li>
			))}
		</ul>
	);

	return (
		<section className="section--hero">
			<div className="hero__content">
				<div className="hero__banner grid">
					<div className="grid__col-12 grid__col-sm-5 grid__col-lg-9 align-start">
						<h1>{title}</h1>
						<p className="hero__lead">{subtitle}</p>
					</div>
					<div className="subscription">
						<header>
							<span>{segment}</span>
						</header>
						<div className="content typography">
							<p className="h2">Subscription</p>
							<p>From {price} EUR/Year</p>
							{featuresList}
							<div className="btn-group btn-group-vertical">
								<a
									href={subscribeLinkUrl}
									className="btn btn--primary"
								>
									Free 14-day trial
								</a>
								<a
									href={subscribeLinkUrl}
									className="btn btn--secondary"
								>
									See pricing options
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

Hero.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string.isRequired,
	segment: PropTypes.oneOf([SEGMENT_CMC, SEGMENT_BZA]).isRequired,
	features: PropTypes.arrayOf(PropTypes.string),
	price: priceType.isRequired,
	subscribeLinkUrl: subscribeLinkType.isRequired,
};
